module.exports = __webpack_public_path__ + "static/media/mobileDefaultModal.55427333.png";